import { useState } from 'react';
import * as S from './DocumentExplanationPopover.styled';
import { InfoIcon } from '../../Table.styled';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import 'react-quill/dist/quill.snow.css';
import { linkifyHtml } from 'utils/v2/document';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const DocumentExplanationPopover = ({ explanation }: { explanation: string }) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <S.Explanation onClick={handleClickOpen}>
                <InfoIcon open={open} />
            </S.Explanation>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <S.FullExplanation>
                    <div
                        className="ql-editor"
                        dangerouslySetInnerHTML={{ __html: linkifyHtml(explanation) }}
                    />
                </S.FullExplanation>
            </BootstrapDialog>
        </>
    );
};

export default DocumentExplanationPopover;
